import { render, staticRenderFns } from "./editEtplega.vue?vue&type=template&id=5f138e0e&"
import script from "./editEtplega.vue?vue&type=script&lang=js&"
export * from "./editEtplega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports